module.exports = __webpack_public_path__ + "img/logo_annex_row_white.51ae20d1.png";